import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import Role from "@/roles.ts";

export default new Vuex.Store({
	state: {
		token: localStorage.getItem("CTC_AUTH_TOKEN"),
		refreshToken: localStorage.getItem("CTC_REFRESH_TOKEN"),
		context: undefined,
		user: JSON.parse(localStorage.getItem("CTC_USER") || '{}'),
	},
	mutations: {
		SET_AUTH(state, params) {
			if (!params.Token) {
				localStorage.removeItem("CTC_AUTH_TOKEN");
				localStorage.removeItem("CTC_REFRESH_TOKEN");
				state.token = null;
				state.refreshToken = null;
				localStorage.removeItem("CTC_USER");
				state.user = undefined;
			} else {
				state.token = params.Token;
				state.refreshToken = params.RefreshToken;
				delete params.Token;
				delete params.RefreshToken;
				state.user = params;
			}
		},
		SET_CONTEXT(state, context) {
			state.context = context;
		},
		SET_USER(state, user) {
			state.user = user;
		},
	},
	actions: {
		init: ({ commit, state }, packages) => {
			commit('SET_CONTEXT', packages.context);
		},
		setAgreed: ({ commit, state }, params) => {
			var user = state.user;
			user.HasAgreedACC = true;
			localStorage.setItem("CTC_USER", JSON.stringify(user));
			commit('SET_USER', user);
			return true;
		},
		refresh: ({ commit, state }, params) => {
			var user = params;
			localStorage.setItem("CTC_AUTH_TOKEN", user.Token);
			localStorage.setItem("CTC_REFRESH_TOKEN", user.RefreshToken);
			localStorage.setItem("CTC_USER", JSON.stringify(user));
			commit('SET_AUTH', user);
			//@ts-ignore
			state.context.$login.ctc();
			//@ts-ignore
			state.context.$login.users();
			//try {
			//    if (user) {
			//        raygun('setUser', {
			//            identifier: user.Id,
			//            isAnonymous: false,
			//            email: user.Username,
			//            fullName: user.Name
			//        });
			//    }

			//} catch (err) {
			//    console.log("failed not free");
			//}
			return user;
		},
		login: async ({ commit, state }, params) => {
			var email = params.Email;
			var password = params.Password;
			try {
				//@ts-ignore
				var response = await state.context.$http.post("api/authentication/login", { Email: email, Password: password });
				localStorage.setItem("CTC_AUTH_TOKEN", response.data.Token);
				localStorage.setItem("CTC_REFRESH_TOKEN", response.data.RefreshToken);
				localStorage.setItem("CTC_USER", JSON.stringify(response.data));
				commit('SET_AUTH', response.data);
				//@ts-ignore
				state.context.$login.ctc();
				//@ts-ignore
				state.context.$login.users();
				//try {
				//    raygun('setUser', {
				//        identifier: response.data.Id,
				//        isAnonymous: false,
				//        email: response.data.Username,
				//        fullName: response.data.Name
				//    });
				//} catch (err) {
				//    console.log("failed not free" + err);
				//}
				return response.data;
			}
			catch (err) {
				//@ts-ignore
				Promise.reject(error);
			}
		},
		logout: ({ commit, state }) => {
			if (state.user) {
				//@ts-ignore
				state.context.$http.post("api/authentication/logout/" + state.user.Id).then(resp => {
					if (!window.frameElement) {
						//@ts-ignore
						state.context.$logout.ctc();
						//@ts-ignore
						state.context.$logout.users();
					}
					//@ts-ignore
					state.context.$router.push({ path: '/login' });
					//@ts-ignore
				}).catch(err => {
					Promise.reject(err);
					if (!window.frameElement) {
						//@ts-ignore
						state.context.$logout.ctc();
						//@ts-ignore
						state.context.$logout.users();
					}
					//@ts-ignore
					state.context.$router.push({ path: '/login' });
				});
			}

			//@ts-ignore
			delete state.context.$http.defaults.headers.common["Authorization"];

			commit('SET_AUTH', {});
		},
		silent_logout: ({ commit, state }) => {
			if (state.user) {
				//@ts-ignore
				state.context.$http.post("api/authentication/logout/" + state.user.Id).then(resp => {
					if (!window.frameElement) {
						//@ts-ignore
						state.context.$logout.ctc();
						//@ts-ignore
						state.context.$logout.users();
					}
					//@ts-ignore
				}).catch(err => {
					Promise.reject(err);
					if (!window.frameElement) {
						//@ts-ignore
						state.context.$logout.ctc();
						//@ts-ignore
						state.context.$logout.users();
					}
				});
			}

			//@ts-ignore
			delete state.context.$http.defaults.headers.common["Authorization"];

			commit('SET_AUTH', {});
		}
	},
	getters: {
		isLoggedIn: state => {
			return !!state.token;
		},
		user: state => {
			return state.user;
		},
		bus: state => {
			return state.context;
		},
		hasAccess: state => {
			//TAKE THE CALCULATOR PRESALE ROLE OUT OF THIS GETTER ON MAY 15th
			return state.user && state.user.Roles && (state.user.Roles.indexOf(Role.ACCFullAccess) > -1 || state.user.Roles.indexOf(Role.AWGMember) > -1 || state.user.Roles.indexOf(Role.AWGMemberACC) > -1);
		},
		hasPreAccess: state => {
			return state.user && state.user.Roles && state.user.Roles.indexOf(Role.ACCFullAccess) > -1;
		}
	}
})
